import { c as _c } from "react/compiler-runtime";
import { ThemedLogoFpFull } from '@onefootprint/icons';
import type React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const MARKETING_SITE_URL = 'https://onefootprint.com';
const Layout = t0 => {
  const $ = _c(13);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "layout"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("authentication", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  useEffect(_temp2, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div aria-hidden={true} className="fp-auth-glow pointer-events-none absolute inset-x-0 -top-5 -z-10 h-[164px]" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp3);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ThemedLogoFpFull className="h-9 w-auto" color="primary" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <header className="p-5"><div className="relative mx-auto max-w-[1640px]">{t3}<a href={MARKETING_SITE_URL} aria-label={t4} className="inline-flex rounded-xs">{t5}</a></div></header>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== children) {
    t7 = <main className="flex flex-1 flex-col items-center justify-center px-4 py-8">{children}</main>;
    $[8] = children;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <div className="fp-auth-brand @container relative isolate flex min-h-[var(--fp-auth-min-height,100dvh)] flex-col overflow-x-clip bg-secondary text-primary">{t6}{t7}</div>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
export default Layout;
function _temp() {
  document.body.classList.remove("fp-auth-brand");
}
function _temp2() {
  document.body.classList.add("fp-auth-brand");
  return _temp;
}
function _temp3($) {
  return $.backToWebsite;
}